import { render, staticRenderFns } from "./statrgyArticleForm.vue?vue&type=template&id=252d3dc7&scoped=true"
import script from "./statrgyArticleForm.vue?vue&type=script&lang=js"
export * from "./statrgyArticleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d3dc7",
  null
  
)

export default component.exports